var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtLink',{staticClass:"link-column-with-image",attrs:{"to":_vm.linkUrl}},[_c('div',{staticClass:"link-column-with-image__image",style:({
      'background-image': _vm.backgroundImageUrl
        ? ("url(" + _vm.backgroundImageUrl + ")")
        : null,
    })}),_vm._v(" "),_c('div',{staticClass:"link-column-with-image__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }